import { abbrNum, convertRatio } from 'utils/helper/common';
import { renderPrice } from 'utils/helper/price';

export const computeDisplayedMetricValue = (
  metricValue: number | string | undefined | null,
  metricField: string,
  defaultNoMetricValue: string | number
): number | string => {
  if (!metricValue || metricValue === 'NA') {
    return defaultNoMetricValue || 0;
  }

  if (metricField === 'engagement') {
    return `${convertRatio(metricValue)}%`;
  }

  if (metricField === 'cpm' || metricField === 'cpe') {
    return renderPrice(metricValue);
  }

  if (Number(metricValue)) {
    return abbrNum(metricValue, { decimal: 1 }, true);
  }

  return metricValue;
};
